import React, { Dispatch } from 'react';
import { FormSelectField } from '../../../../common/form/form-select-field';
import { useTranslation } from 'react-i18next';

interface TierSelectProps {
  isDisabled: boolean,
  id: string,
  name: string,
  value: string,
  handleChange: Dispatch<{target: {name: string, value: string}}>,
}

enum BUSINESS_TIERS {
  UNVERIFIED = 'UNVERIFIED',
  BASIC = 'BASIC',
  PRO = 'PRO'
}

const BusinessTierSelect: React.FC <TierSelectProps> = (props) => {
  const { isDisabled, value, handleChange } = props;
  const { t } = useTranslation();

  const tierOptions = Object.values(BUSINESS_TIERS).map((tier) => ({
    label: t(`clubPage.tier_options.${tier}`),
    value: tier
  }));

  return (
    <div>
      <FormSelectField
        id='club_form_tier'
        label={t('clubPage.tier')}
        name='tier'
        value={value}
        isDisabled={isDisabled}
        options={tierOptions}
        handleChange={handleChange}
      />
    </div>
  );
};

export { BusinessTierSelect, BUSINESS_TIERS };
